// Browser-local calendar day helpers shared by Ads Assistant + Sales daily
// checklist. Wraps the same pattern previously inlined as
// `salesChecklistLocalDayBounds` so we have one canonical source of truth for
// "today" boundaries. The follow-up app-wide TZ audit is tracked in
// docs/planning/ads_assistant_gamification_org_activity.md.

/** Local calendar `YYYY-MM-DD` in the browser timezone. */
export function clientLocalCalendarDay(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Midnight-to-end-of-day ISO bounds for the rep's local calendar day. */
export function clientLocalDayBounds(): { logged_after: string; logged_before: string } {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
  return { logged_after: start.toISOString(), logged_before: end.toISOString() };
}
